export const ACTIVITY_CARD_CLASS =
  'flex flex-col gap-2 rounded-xl px-4 py-3 shadow-xs ring-[6px] ring-background transition-[transform,box-shadow] duration-150 ease-out ring-inset hover:-translate-y-px hover:scale-[1.005] hover:shadow-sm';
